module.exports = __webpack_public_path__ + "static/media/back.6575b069.svg";